/** @typedef {import('./officeJsHost').OutlookHost} OutlookHost */

import { createOfficeJsHost } from "./officeJsHost";
import { createVstoBridgeHost } from "./vstoBridgeHost";
import { createMockVstoHost } from "./mockVstoHost";

/**
 * @returns {URLSearchParams}
 */
const getSearchParams = () => {
  try {
    return new URLSearchParams(window.location.search);
  } catch {
    return new URLSearchParams();
  }
};

/**
 * Resolves which host adapter to use based on URL params and runtime context.
 * @returns {OutlookHost}
 */
export const createHost = () => {
  const params = getSearchParams();
  const hostParam = params.get("host") || window.__UNICLI_HOST__;
  const inWebView = !!window.chrome?.webview;

  // Require explicit ?host=vsto — Outlook's Office add-in task pane also runs in WebView2
  // and exposes window.chrome.webview, so we must not auto-detect VSTO from that alone.
  if (hostParam === "vsto") {
    if (params.get("mock") === "1" || !inWebView) {
      return createMockVstoHost();
    }
    return createVstoBridgeHost();
  }

  return createOfficeJsHost();
};

/**
 * @returns {boolean}
 */
export const isVstoHost = (host) => host?.kind === "vsto";

export { createOfficeJsHost, createVstoBridgeHost, createMockVstoHost };
